class n {
  node;
  rect;
  location;
  index;
  className;
  constructor(s, t, o, c, e) {
    this.node = s, this.rect = t, this.location = o, this.index = c, this.className = e;
  }
}
export {
  n as DropInfo
};
//# sourceMappingURL=DropInfo.js.map
